import React, { useState, useEffect, useRef } from "react";
import videojs from 'video.js';
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
// import {  Row, Col, Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
// import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import { CompactWatchlistButtons } from "../../../components/WatchlistButtons";
//img

import 'videojs-seek-buttons/dist/videojs-seek-buttons.css';
import 'videojs-contrib-quality-levels/dist/videojs-contrib-quality-levels';
import 'videojs-seek-buttons';

import Video from "../pages/video";
import trailer from "../../../assets/images/movie-banner/1.jpg";
import start1 from "../../../assets/images/star/star1.jpg";
import start2 from "../../../assets/images/star/star2.jpg";
import upcoming1 from "../../../assets/images/upcoming/01.jpg";
import upcoming2 from "../../../assets/images/upcoming/02.jpg";
import upcoming3 from "../../../assets/images/upcoming/03.jpg";
import upcoming4 from "../../../assets/images/upcoming/04.jpg";
import upcoming5 from "../../../assets/images/upcoming/05.jpg";
import poster from "../../../assets/images/jpg2png/05.png";

import VideoJS from '../pages/video'
import video from '../../../assets/video/Minions.mp4'
import videoplayer from "video.js";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";
import axios from "axios";
import { TMDB_CONFIG, getImageUrl, getPosterUrl } from "../../../config/tmdb";

// Add custom styles for episode components
const customStyles = `
  .episode-rating-overlay {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 20px;
    padding: 5px 10px;
    z-index: 10;
  }
  
  .episode-rating {
    color: #ffc107;
    font-size: 0.8rem;
    font-weight: 600;
  }
  
  .play-episode-btn {
    background: rgba(0, 0, 0, 0.7);
    border: 2px solid #fff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    transition: all 0.3s ease;
  }
  
  .play-episode-btn:hover:not(.loading) {
    background: rgba(0, 123, 255, 0.8);
    transform: scale(1.1);
  }
  
  .play-episode-btn.loading {
    background: rgba(108, 117, 125, 0.7);
    cursor: not-allowed;
    opacity: 0.7;
  }
  
  .play-episode-btn .spinner-border-sm {
    width: 1rem;
    height: 1rem;
    color: white;
  }
  
  .episode-overview {
    font-size: 0.85rem !important;
    line-height: 1.4;
    max-height: 60px;
    overflow: hidden;
  }
  
  .e-item {
    transition: transform 0.3s ease;
  }
  
  .e-item:hover {
    transform: translateY(-5px);
  }
  
  .season-controls {
    background: rgba(0, 0, 0, 0.1);
    padding: 15px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .btn-season-play {
    border-color: #007bff;
    color: #007bff;
    font-weight: 600;
    transition: all 0.3s ease;
  }
  
  .btn-season-play:hover:not(.loading) {
    background-color: #007bff;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  }
  
  .btn-season-play.loading {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  .season-video-count {
    padding: 8px 12px;
    background: rgba(40, 167, 69, 0.1);
    border-radius: 20px;
    border: 1px solid rgba(40, 167, 69, 0.3);
  }
  
  .season-play-button {
    transition: all 0.3s ease;
  }
  
  .season-play-button:hover {
    transform: translateY(-1px);
  }
`;

const ShowList = () => {
  const { id: routeShowId } = useParams();
  const [activeTab, setActiveTab] = useState("episodes");
  const playerRef = useRef(null);
 
  // TMDB TV Videos state
  const [tvVideos, setTvVideos] = useState({
    videos: [],
    loading: false,
    error: null,
  });
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Seasons/Episodes state
  const [seasons, setSeasons] = useState([]);
  const [selectedSeason, setSelectedSeason] = useState(1);
  const [seasonVideos, setSeasonVideos] = useState({
    videos: [],
    loading: false,
    error: null,
  });
  const [episodes, setEpisodes] = useState([]);
  const [selectedEpisode, setSelectedEpisode] = useState(null);

  // Complete TV Show Details
  const [tvShowDetails, setTvShowDetails] = useState({
    data: null,
    loading: false,
    error: null
  });

  // Season Details cache
  const [seasonDetailsCache, setSeasonDetailsCache] = useState({});
  
  // Cast/Credits state
  const [castData, setCastData] = useState({
    cast: [],
    loading: false,
    error: null
  });

  // Recommended Shows state
  const [recommendedShows, setRecommendedShows] = useState({
    shows: [],
    loading: false,
    error: null
  });

  // Fetch complete TV Show details
  const fetchTVShowDetails = async (seriesId) => {
    if (!seriesId) return;
    setTvShowDetails(prev => ({ ...prev, loading: true, error: null }));
    try {
      const url = `${TMDB_CONFIG.BASE_URL}/tv/${seriesId}?language=en-US&append_to_response=videos,credits,similar`;
      
      const options = {
        method: 'GET',
        url: url,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };
      
      const response = await axios.request(options);
      const showData = response.data;
      
      // Process the complete show data
      const processedShowData = {
        ...showData,
        thumbnail_image: getImageUrl(showData.backdrop_path),
        poster_image: getPosterUrl(showData.poster_path),
        // Format vote average
        vote_average: showData.vote_average?.toFixed(1) || 'N/A',
        // Format air dates
        first_air_date: showData.first_air_date,
        last_air_date: showData.last_air_date,
        // Episode runtime
        episode_run_time: showData.episode_run_time?.[0] || null,
        // Number of seasons and episodes
        number_of_seasons: showData.number_of_seasons,
        number_of_episodes: showData.number_of_episodes,
        // Status and networks
        status: showData.status,
        networks: showData.networks || [],
        created_by: showData.created_by || [],
        genres: showData.genres || [],
        overview: showData.overview || 'No overview available'
      };
      
      setTvShowDetails({
        data: processedShowData,
        loading: false,
        error: null
      });
      
      console.log('Complete TV Show Details:', processedShowData);
      return processedShowData;
    } catch (error) {
      console.error('Error fetching TV show details:', error);
      setTvShowDetails(prev => ({
        ...prev,
        loading: false,
        error: error.message
      }));
      toast.error('Failed to load show details');
      throw error;
    }
  };

  const fetchTVVideos = async (seriesId) => {
    if (!seriesId) return;
    setTvVideos((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/tv/${seriesId}/videos?language=en-US`,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };
      const res = await axios.request(options);
      const results = res.data?.results || [];
      const best = results.find(v => v.type === 'Trailer' && v.site === 'YouTube')
        || results.find(v => v.type === 'Teaser' && v.site === 'YouTube')
        || results.find(v => v.site === 'YouTube')
        || null;
      setTvVideos({ videos: results, loading: false, error: null });
      setSelectedVideo(best);
      if (!best) toast.error('No playable videos available for this TV show');
    } catch (err) {
      setTvVideos((prev) => ({ ...prev, loading: false, error: err.message || 'Failed to fetch TV videos' }));
      toast.error('Failed to load TV videos');
    }
  };

  useEffect(() => {
    if (routeShowId) {
      // Fetch complete show details
      fetchTVShowDetails(routeShowId);
      // Fetch TV videos
      fetchTVVideos(routeShowId);
      // Fetch TV details to build seasons list
      (async () => {
        try {
          const res = await axios.get(`${TMDB_CONFIG.BASE_URL}/tv/${routeShowId}?language=en-US`, {
            headers: {
              accept: 'application/json',
              Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
            }
          });
          const count = res.data?.number_of_seasons || 1;
          const list = Array.from({ length: count }, (_, i) => i + 1);
          setSeasons(list);
          setSelectedSeason(list[0] || 1);
        // Preload episodes for first season
        if (list[0]) {
          await loadSeasonEpisodes(routeShowId, list[0]);
        }
      } catch (e) {
        // ignore
      }

      // Load cast data
      fetchCastData(routeShowId);
      
      // Load recommended shows
      fetchRecommendedShows();
      })();
      } else {
      // Load recommended shows even if no show ID
      fetchRecommendedShows();
    }
  }, [routeShowId]);

  // Fetch Season videos using the exact API endpoint format provided
  const fetchSeasonVideos = async (seriesId, seasonNumber) => {
    if (!seriesId || !seasonNumber) return;
    
    setSeasonVideos(prev => ({ ...prev, loading: true, error: null }));
    
    try {
      // Use the exact endpoint format provided by the user
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/tv/${seriesId}/season/${seasonNumber}/videos?language=en-US`,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };
      
      const response = await axios.request(options);
      const results = response.data?.results || [];
      
      console.log(`Season ${seasonNumber} videos:`, results);
      
      setSeasonVideos({ videos: results, loading: false, error: null });
      
      // Find the best season video to play - prioritize by type
      const bestSeasonVideo = results.find(v => v.type === 'Trailer' && v.site === 'YouTube') ||
                              results.find(v => v.type === 'Teaser' && v.site === 'YouTube') ||
                              results.find(v => v.site === 'YouTube') ||
                              results.find(v => v.site === 'Vimeo') ||
                              null;
      
      if (bestSeasonVideo) {
        setSelectedVideo(bestSeasonVideo);
        
        // Show success toast with season video info
        toast.success(`Playing Season ${seasonNumber}: ${bestSeasonVideo.name || 'Season Video'}`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        
        console.log('Selected season video for playback:', bestSeasonVideo);
      } else {
        console.log(`No videos found for Season ${seasonNumber}`);
      }
      
    } catch (error) {
      console.error(`Error fetching season ${seasonNumber} videos:`, error);
      setSeasonVideos(prev => ({ 
        ...prev, 
        loading: false, 
        videos: [],
        error: error.response?.data?.status_message || error.message || 'Failed to fetch season videos'
      }));
      
      toast.error(`Failed to load Season ${seasonNumber} videos`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  };

  // Fetch Cast/Credits data for starring section
  const fetchCastData = async (seriesId) => {
    if (!seriesId) return;
    
    setCastData(prev => ({ ...prev, loading: true, error: null }));
    
    try {
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/tv/${seriesId}/credits?language=en-US`,
        
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };
      
      const response = await axios.request(options);
      const { cast } = response.data;
      
      console.log(`Cast data for TV Show ${seriesId}:`, cast);
      
      // Process cast data to include image URLs
      const processedCast = cast.slice(0, 8).map(castMember => ({
        id: castMember.id,
        name: castMember.name,
        character: castMember.character || 'Unknown Character',
        profile_path: castMember.profile_path,
        profile_image_url: castMember.profile_path ? 
          `${TMDB_CONFIG.IMAGE_BASE_URL}/w300${castMember.profile_path}` : 
          null,
        gender: castMember.gender,
        order: castMember.order,
        known_for_department: castMember.known_for_department || 'Acting'
      }));
      
      setCastData({
        cast: processedCast,
        loading: false,
        error: null
      });
      
      console.log('Processed cast data:', processedCast);
      
    } catch (error) {
      console.error(`Error fetching cast data for TV Show ${seriesId}:`, error);
      setCastData({
        cast: [],
        loading: false,
        error: error.response?.data?.status_message || error.message || 'Failed to fetch cast data'
      });
      
      toast.error('Failed to load cast information', {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  };

  // Fetch Popular TV Shows for Recommended Shows section
  const fetchRecommendedShows = async () => {
    setRecommendedShows(prev => ({ ...prev, loading: true, error: null }));
    
    try {
      const options = {
        method: 'GET',
        url: 'https://api.themoviedb.org/3/tv/popular?language=en-US&page=1',
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };
      
      const response = await axios.request(options);
      const shows = response.data.results || [];
      
      console.log('Popular TV Shows for recommended section:', shows);
      
      // Process shows data to include image URLs and formatted data
      const processedShows = shows.slice(0, 8).map(show => ({
        id: show.id,
        title: show.name || 'Untitled TV Show',
        original_name: show.original_name,
        overview: show.overview || 'No overview available',
        vote_average: show.vote_average?.toFixed(1) || 'N/A',
        vote_average_display: show.vote_average ? `⭐ ${show.vote_average.toFixed(1)}` : '⭐ N/A',
        poster_path: show.poster_path,
        poster_image_url: show.poster_path ? 
          `${TMDB_CONFIG.IMAGE_BASE_URL}/w500${show.poster_path}` : 
          null,
        backdrop_path: show.backdrop_path,
        backdrop_image_url: show.backdrop_path ? 
          `${TMDB_CONFIG.IMAGE_BASE_URL}/w500${show.backdrop_path}` : 
          null,
        first_air_date: show.first_air_date,
        release_year: show.first_air_date ? 
          new Date(show.first_air_date).getFullYear().toString() : 
          'N/A',
        genre_ids: show.genre_ids || [],
        popularity: show.popularity,
        original_language: show.original_language,
        origin_country: show.origin_country || [],
        adult: show.adult || false,
        media_type: 'tv'
      }));
      
      setRecommendedShows({
        shows: processedShows,
        loading: false,
        error: null
      });
      
      console.log('Processed recommended shows:', processedShows);
      
    } catch (error) {
      console.error('Error fetching popular TV shows:', error);
      setRecommendedShows({
        shows: [],
        loading: false,
        error: error.response?.data?.status_message || error.message || 'Failed to fetch recommended shows'
      });
      
      toast.error('Failed to load recommended shows', {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  };

  // Load season details to build episode list with complete episode information
  const loadSeasonEpisodes = async (seriesId, seasonNumber) => {
    // Check cache first
    const cacheKey = `${seriesId}_${seasonNumber}`;
    if (seasonDetailsCache[cacheKey]) {
      setEpisodes(seasonDetailsCache[cacheKey].episodes);
      setSelectedEpisode(seasonDetailsCache[cacheKey].episodes[0]?.episode_number || null);
      return seasonDetailsCache[cacheKey];
    }
    
    try {
      const url = `${TMDB_CONFIG.BASE_URL}/tv/${seriesId}/season/${seasonNumber}?language=en-US`;
      
      const options = {
        method: 'GET',
        url: url,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };
      
      const response = await axios.request(options);
      const seasonData = response.data;
      
      // Process episodes data with full details
      const processedEpisodes = seasonData.episodes?.map(episode => ({
        ...episode,
        still_path_full: getPosterUrl(episode.still_path),
        vote_average_display: episode.vote_average?.toFixed(1) || 'N/A',
        runtime_display: episode.runtime ? `${episode.runtime} min` : 'N/A',
        crew_processed: episode.crew?.slice(0, 5).map(person => ({
          name: person.name,
          role: person.job
        })) || [],
        guest_stars_processed: episode.guest_stars?.slice(0, 3).map(person => ({
          name: person.name,
          character: person.character
        })) || []
      })) || [];
      
      const seasonInfo = {
        id: seasonData.id,
        name: seasonData.name,
        overview: seasonData.overview,
        season_number: seasonData.season_number,
        episode_count: seasonData.episode_count,
        air_date: seasonData.air_date,
        poster_path_full: getPosterUrl(seasonData.poster_path)
      };
      
      const completeSeasonData = {
        seasonInfo,
        episodes: processedEpisodes
      };
      
      // Cache the data
      setSeasonDetailsCache(prev => ({
        ...prev,
        [cacheKey]: completeSeasonData
      }));
      
      setEpisodes(processedEpisodes);
      setSelectedEpisode(processedEpisodes[0]?.episode_number || null);
      
      console.log(`Season ${seasonNumber} episodes loaded:`, completeSeasonData);
      return completeSeasonData;
    } catch (error) {
      console.error(`Error fetching season ${seasonNumber} episodes:`, error);
      toast.error(`Failed to load season ${seasonNumber} episodes`);
      setEpisodes([]);
      setSelectedEpisode(null);
      return null;
    }
  };

  // Fetch episode-level videos using the exact API endpoint format provided
  const fetchEpisodeVideos = async (seriesId, seasonNumber, episodeNumber) => {
    if (!seriesId || !seasonNumber || !episodeNumber) return;
    
    setSeasonVideos(prev => ({ ...prev, loading: true, error: null }));
    
    try {
      // Use the exact endpoint format provided by the user
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/tv/${seriesId}/season/${seasonNumber}/episode/${episodeNumber}/videos?language=en-US`,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };
      
      const response = await axios.request(options);
      const results = response.data?.results || [];
      
      console.log(`Episode videos for S${seasonNumber}E${episodeNumber}:`, results);
      
      setSeasonVideos({ videos: results, loading: false, error: null });
      
      // Find the best video to play - prioritize by type
      const bestVideo = results.find(v => v.type === 'Trailer' && v.site === 'YouTube') ||
                       results.find(v => v.type === 'Teaser' && v.site === 'YouTube') ||
                       results.find(v => v.site === 'YouTube') ||
                       results.find(v => v.site === 'Vimeo') ||
                       null;
      
      if (bestVideo) {
        setSelectedVideo(bestVideo);
        
        // Show success toast with video info
        toast.success(`Playing: ${bestVideo.name || 'Episode Video'}`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        
        console.log('Selected video for playback:', bestVideo);
      } else {
        toast.warning('No playable video found for this episode', {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      }
      
    } catch (error) {
      console.error(`Error fetching episode videos for S${seasonNumber}E${episodeNumber}:`, error);
      setSeasonVideos(prev => ({ 
        ...prev, 
        loading: false, 
        results: [],
        error: error.response?.data?.status_message || error.message || 'Failed to fetch episode videos'
      }));
      
      toast.error('Failed to load episode video', {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  };



  const videoJsOptions = {
    autoplay: true,
    controls: true,
    responsive: true,
    poster : '../../../assets/images/jpg2png/05.png',
    fluid:  true,
    sources: [{
      src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
      type: 'video/mp4'
    }],
    controlBar: {
      skipButtons: {
        forward: 10,
          backward: 10
      }
    },
  };
  
  
  

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    player.on('waiting', () => {
      videojs.log('player is waiting');
    });

    player.on('dispose', () => {
      videojs.log('player will dispose');
    });
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // const handleTabClick = (tabId) => {
  //   setActiveTab(tabId);
  // };

  const upcomingData = [
    {
      title: "The Last Breath",
      imageUrl: upcoming1,
      ageRating: "5+",
      duration: "2h 30m",
    },
    {
      title: "Shadow",
      imageUrl: upcoming2,
      ageRating: "22+",
      duration: "2h 15m",
    },
    {
      title: "Another Danger",
      imageUrl: upcoming3,
      ageRating: "25+",
      duration: "3h",
    },
    {
      title: "1980",
      imageUrl: upcoming4,
      ageRating: "11+",
      duration: "2h 45m",
    },
    {
      title: "Vugotronic",
      imageUrl: upcoming5,
      ageRating: "9+",
      duration: "2h 30m",
    },
  ];
  const related = [
    {
      title: "The Last Breath",
      imageUrl: upcoming1,
      ageRating: "5+",
      duration: "2h 30m",
    },
    {
      title: "Shadow",
      imageUrl: upcoming2,
      ageRating: "22+",
      duration: "2h 15m",
    },
    {
      title: "Another Danger",
      imageUrl: upcoming3,
      ageRating: "25+",
      duration: "3h",
    },
    {
      title: "1980",
      imageUrl: upcoming4,
      ageRating: "11+",
      duration: "2h 45m",
    },
    {
      title: "Vugotronic",
      imageUrl: upcoming5,
      ageRating: "9+",
      duration: "2h 30m",
    },
  ];

  const handleAddClick = (Data) => {
    toast.success(Data, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const copyURL = () => {
    const url = window.location.href;
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = url;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toast.success("URL copied to clipboard: " + url);
  };
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: customStyles }} />
      {tvVideos.loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{height: '60vh'}}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <p className="text-white mt-3">Loading video...</p>
          </div>
        </div>
      ) : selectedVideo ? (
        <div style={{ width: '100%', background: '#000' }}>
          {/* Episode Video Header */}
          <div className="episode-video-header" style={{ 
            background: 'linear-gradient(135deg, rgba(0,0,0,0.8), rgba(13,110,253,0.3))',
            padding: '20px 0',
            borderBottom: '3px solid #007bff'
          }}>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h2 className="text-white mb-2">
                    <i className="ri-play-circle-line mr-2"></i>
                    {selectedVideo.name || 'Episode Video'}
                  </h2>
                  <div className="episode-video-info text-white-50">
                    <span className="mr-3">
                      <i className="ri-television-line mr-1"></i>
                      Season {selectedSeason} • {selectedVideo.name ? 'Season Video' : 'Episode from TMDB'}
                    </span>
                    <span className="mr-3">
                      <i className="ri-time-line mr-1"></i>
                      Type: {selectedVideo.type || 'Video'}
                    </span>
                    {selectedVideo.site && (
                      <span>
                        <i className="ri-git-hub-line mr-1"></i>
                        Source: {selectedVideo.site}
                      </span>
                    )}
                    {seasonVideos.videos && seasonVideos.videos.length > 1 && (
                      <span className="ml-3">
                        <i className="ri-videoline mr-1"></i>
                        {seasonVideos.videos.length} total videos
                      </span>
                    )}
                  </div>
                </div>
                {/* <div className="col-md-4 text-right">
                  <button 
                    className="btn btn-outline-light btn-sm"
                    onClick={() => setSelectedVideo(null)}
                    title="Close Video"
                  >
                    <i className="ri-close-line mr-1"></i>
                    Close
                  </button>
                </div> */}
              </div>
            </div>
          </div>
          
          <div style={{ maxWidth: 1280, margin: '0 auto' }}>
            <ReactPlayer
              ref={playerRef}
              url={`https://www.youtube.com/watch?v=${selectedVideo.key}`}
              width="100%"
              height="60vh"
              controls
              playing
              onReady={() => {
                console.log('Episode video player ready:', selectedVideo);
                toast.success('Episode video loaded successfully!', {
                  position: "top-right",
                  autoClose: 2000,
                });
              }}
              onError={(error) => {
                console.error('Episode video player error:', error);
                toast.error('Failed to load episode video. Please try again.', {
                  position: "top-right",
                  autoClose: 3000,
                });
              }}
            />
          </div>
        </div>
      ) : (
        <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
      )}

      <div class="main-content">
        <div class="show-movie">
          <div class="container-fluid">
          
            <section className="show-movie-section">
              <div className="season-controls d-flex align-items-center gap-3 mb-4">
                <div className="iq-custom-select sea-epi">
                  <select 
                    name="seasons" 
                    className="form-control season-select"
                    value={selectedSeason}
                  onChange={(e) => {
                    const newSeason = parseInt(e.target.value);
                    setSelectedSeason(newSeason);
                    if (routeShowId) {
                      loadSeasonEpisodes(routeShowId, newSeason);
                      // Also try to load season videos in the background
                      fetchSeasonVideos(routeShowId, newSeason);
                    }
                  }}
                  >
                    {seasons.map(seasonNum => (
                      <option key={seasonNum} value={seasonNum}>
                        Season {seasonNum}
                      </option>
                    ))}
                  </select>
                </div>
                
                {/* Season Play Button */}
                <div className="season-play-button">
                  <button 
                    className={`btn btn-outline-primary btn-season-play ${seasonVideos.loading ? 'loading' : ''}`}
                    onClick={() => {
                      if (routeShowId && !seasonVideos.loading) {
                        fetchSeasonVideos(routeShowId, selectedSeason);
                      }
                    }}
                    disabled={seasonVideos.loading || !routeShowId}
                    title={seasonVideos.loading ? "Loading season video..." : `Play Season ${selectedSeason} Videos`}
                  >
                    {seasonVideos.loading ? (
                      <>
                        <div className="spinner-border spinner-border-sm mr-2" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        Loading...
                      </>
                    ) : (
                      <>
                        <i className="ri-play-circle-line mr-2"></i>
                        Play Season {selectedSeason}
                      </>
                    )}
                  </button>
                </div>
                
                {/* Season Video Info */}
                {seasonVideos.videos && seasonVideos.videos.length > 0 && (
                  <div className="season-video-count">
                    <small className="text-success">
                      <i className="ri-videoline mr-1"></i>
                      {seasonVideos.videos.length} video{seasonVideos.videos.length !== 1 ? 's' : ''} available
                    </small>
                  </div>
                )}
              </div>
              <div className="trending-custom-tab">
                <div className="tab-title-info position-relative">
                  {/* <ul className="trending-pills nav nav-pills text-center iq-ltr-direction" role="tablist">
                           <li className="nav-item">
                              <Link className="nav-link active show m-0 " data-toggle="pill" href="#episodes" role="tab"
                                 aria-selected="true" onClick={() => handleTabClick('episodes')}>Episodes</Link>
                                 
                           </li>
                           <li className="nav-item">
                              <Link className="nav-link  m-0" data-toggle="pill" href="#feature-clips" role="tab"
                                 aria-selected="false" onClick={() => handleTabClick('feature-clips')}>FEATURED CLIPS</Link>
                                
                           </li>
                        </ul> */}

                  <ul
                    className="trending-pills nav nav-pills text-center iq-ltr-direction"
                    role="tablist"
                  >
                    <li
                      className={`nav-item ${
                        activeTab === "episodes" ? "active" : ""
                      }`}
                    >
                      <Link
                        className="nav-link "
                        to="#episodes"
                        role="tab"
                        aria-selected={
                          activeTab === "episodes" ? "true" : "false"
                        }
                        onClick={() => handleTabClick("episodes")}
                      >
                        Episodes
                      </Link>
                    </li>
                    <li
                      className={`nav-item ${
                        activeTab === "feature-clips" ? "active" : ""
                      }`}
                    >
                      <Link
                        className="nav-link"
                        to="#feature-clips"
                        role="tab"
                        aria-selected={
                          activeTab === "feature-clips" ? "true" : "false"
                        }
                        onClick={() => handleTabClick("feature-clips")}
                      >
                        FEATURED CLIPS
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="nav-tabContent">
                  {/* <div id="episodes" className=" tab-pane animated fadeInUp active show"> */}
                  <div
                    id="episodes"
                    className={`tab-pane animated fadeInUp ${
                      activeTab === "episodes" ? "active show" : ""
                    }`}
                  >
                    <div class="row episodes list-inline p-0 mb-0 iq-rtl-direction ">
                      {/* Dynamic Episodes will be rendered here */}
                      {!episodes || episodes.length === 0 ? (
                        <div className="col-12 py-5">
                          <div className="text-center">
                            {seasons.length === 0 ? (
                              <>
                                <div className="spinner-border text-primary mb-3" role="status">
                                  <span className="sr-only">Loading...</span>
                                </div>
                                <p className="text-white">Loading season information...</p>
                              </>
                            ) : (
                              <>
                                <i className="ri-film-line text-primary mb-3" style={{fontSize: '3rem'}}></i>
                                <p className="text-white">No episodes found for this season</p>
                                <small className="text-white-50">Please try a different season</small>
                              </>
                            )}
                          </div>
                        </div>
                      ) : (
                        episodes.map((episode, index) => (
                          <div key={episode.id || index} className="e-item col-lg-3 col-sm-12 col-md-6 mb-4">
                            <div className="block-image position-relative">
                              <img
                                src={episode.still_path_full || trailer}
                                className="img-fluid img-zoom"
                                alt={`${episode.name || 'Episode'} thumbnail`}
                                loading="lazy"
                                onError={(e) => {
                                  e.target.src = trailer;
                                }}
                              />
                              <div className="episode-number">
                                S{selectedSeason.toString().padStart(2, '0')}E{episode.episode_number?.toString().padStart(2, '0')}
                              </div>
                              <div className="episode-play-info">
                                <div className="episode-play">
                                  <button 
                                    className={`btn-link play-episode-btn ${seasonVideos.loading ? 'loading' : ''}`}
                                    onClick={() => {
                                      if (routeShowId && !seasonVideos.loading) {
                                        fetchEpisodeVideos(routeShowId, selectedSeason, episode.episode_number);
                                      }
                                    }}
                                    title={seasonVideos.loading ? "Loading..." : "Play Episode"}
                                    disabled={seasonVideos.loading}
                                  >
                                    {seasonVideos.loading ? (
                                      <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="sr-only">Loading...</span>
                                      </div>
                                    ) : (
                                      <i className="ri-play-fill"></i>
                                    )}
                                  </button>
                                </div>
                              </div>
                              
                              {/* Episode Rating Overlay */}
                              {episode.vote_average && episode.vote_average > 0 && (
                                <div className="episode-rating-overlay">
                                  <span className="episode-rating">
                                    <i className="ri-star-fill mr-1"></i>
                                    {episode.vote_average_display}
                                  </span>
                                </div>
                              )}
                            </div>
                            
                            <div className="epi-desc p-3">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <span className="text-white rel-date">
                                  {episode.air_date ? new Date(episode.air_date).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric'
                                  }) : 'N/A'}
                                </span>
                                <span className="text-primary run-time">{episode.runtime_display}</span>
                              </div>
                              
                              <div className="episode-info">
                                <h5 className="epi-name text-white mb-2">
                                  {episode.name || `Episode ${episode.episode_number}`}
                                </h5>
                                
                                {/* Episode Overview */}
                                {episode.overview && (
                                  <p className="episode-overview text-white-50 mb-2 small" 
                                     style={{
                                       lineHeight: '1.4',
                                       display: '-webkit-box',
                                       WebkitLineClamp: 3,
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden'
                                     }}
                                  >
                                    {episode.overview}
                                  </p>
                                )}
                                
                                {/* Episode Video Status */}
                                <div className="episode-video-status">
                                  <small className="text-success d-flex align-items-center">
                                    <i className="ri-play-circle-line mr-1"></i>
                                    Episode video available
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                  {/* <div id="feature-clips" class="tab-pane animated fadeInUp"> */}
                  <div
                    id="feature-clips"
                    className={`tab-pane animated fadeInUp ${
                      activeTab === "feature-clips" ? "active show" : ""
                    }`}
                  >
                    <div class="row episodes list-inline p-0 mb-0 iq-rtl-direction">
                      <div class="e-item col-lg-3 col-sm-12 col-md-6">
                        <div class="block-image position-relative">
                          <a href="show-details.html">
                            <img
                              src={trailer}
                              class="img-fluid img-zoom"
                              alt=""
                              loading="lazy"
                            />
                          </a>
                          <div class="episode-number">S01E01</div>
                          <div class="episode-play-info">
                            <div class="episode-play">
                              <a href="show-detail.html">
                                <i class="ri-play-fill"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="epi-desc p-3">
                          <div class="d-flex align-items-center justify-content-between mb-3">
                            <span class="text-white rel-date">
                              October 1, 2020
                            </span>
                            <span class="text-primary run-time">45min</span>
                          </div>
                          <a href="show-detail.html">
                            <h5 class="epi-name text-white mb-0">
                              The Reckless 1{" "}
                            </h5>
                          </a>
                        </div>
                      </div>
                      <div class="e-item col-lg-3 col-sm-12 col-md-6">
                        <div class="block-image position-relative">
                          <a href="show-details.html">
                            <img
                              src={trailer}
                              class="img-fluid img-zoom"
                              alt=""
                              loading="lazy"
                            />
                          </a>
                          <div class="episode-number">S01E02</div>
                          <div class="episode-play-info">
                            <div class="episode-play">
                              <a href="show-details.html" tabindex="0">
                                <i class="ri-play-fill"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="epi-desc p-3">
                          <div class="d-flex align-items-center justify-content-between mb-3">
                            <span class="text-white rel-date">
                              October 8, 2020
                            </span>
                            <span class="text-primary run-time">35min</span>
                          </div>
                          <a href="show-detail.html">
                            <h5 class="epi-name text-white mb-0">
                              The Reckless 2{" "}
                            </h5>
                          </a>
                        </div>
                      </div>
                      <div class="e-item col-lg-3 col-sm-12 col-md-6">
                        <div class="block-image position-relative">
                          <a href="show-details.html">
                            <img
                              src={trailer}
                              class="img-fluid img-zoom"
                              alt=""
                              loading="lazy"
                            />
                          </a>
                          <div class="episode-number">S01E02</div>
                          <div class="episode-play-info">
                            <div class="episode-play">
                              <a href="show-details.html" tabindex="0">
                                <i class="ri-play-fill"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="epi-desc p-3">
                          <div class="d-flex align-items-center justify-content-between mb-3">
                            <span class="text-white rel-date">
                              October 8, 2020
                            </span>
                            <span class="text-primary run-time">35min</span>
                          </div>
                          <a href="show-detail.html">
                            <h5 class="epi-name text-white mb-0">
                              The Reckless 2{" "}
                            </h5>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div
              id="iq-favorites"
              className="s-margin my-5 detail-cast-list iq-rtl-direction mt-0 starring"
            >
              <div className="row m-0">
                <div className="col-sm-12 overflow-hidden p-0">
                  <div className="iq-main-header d-flex align-items-center justify-content-between iq-ltr-direction">
                    <h4 className="main-title">Starring</h4>
                  </div>
                  <div className="favorites-contens iq-smovie-slider">
                    {castData.loading ? (
                      <div className="d-flex justify-content-center align-items-center py-5">
                        <div className="text-center">
                          <div className="spinner-border text-primary mb-3" role="status">
                            <span className="sr-only">Loading cast...</span>
                          </div>
                          <p className="text-white">Loading cast information...</p>
                        </div>
                      </div>
                    ) : castData.error ? (
                      <div className="d-flex justify-content-center align-items-center py-5">
                        <div className="text-center">
                          <i className="ri-error-warning-line text-warning mb-3" style={{fontSize: '3rem'}}></i>
                          <p className="text-white">Failed to load casting details</p>
                          <small className="text-white-50">{castData.error}</small>
                        </div>
                      </div>
                    ) : castData.cast.length === 0 ? (
                      <div className="d-flex justify-content-center align-items-center py-5">
                        <div className="text-center">
                          <i className="ri-user-line text-primary mb-3" style={{fontSize: '3rem'}}></i>
                          <p className="text-white">No cast information available</p>
                          <small className="text-white-50">Please try refreshing the page</small>
                        </div>
                      </div>
                    ) : (
                      <ul className="inner-slider list-inline row p-0 iq-ltr-direction">
                        {castData.cast.map((castMember, index) => (
                          <li key={castMember.id || index} className="slide-item iq-ltr-direction col-xl-3 col-lg-4 col-md-4 col-6">
                            <div className="cast-images position-relative row mx-0">
                              <div className="col-sm-4 col-12 img-box p-0">
                                <img 
                                  src={castMember.profile_image_url || start1} 
                                  alt={`${castMember.name} profile`}
                                  loading="lazy"
                                  style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'cover',
                                    borderRadius: '8px'
                                  }}
                                  onError={(e) => {
                                    e.target.src = start1; // fallback to original image
                                  }}
                                />
                              </div>
                              <div
                                className="col-sm-8 col-12 block-description starring-desc"
                                style={{
                                  marginLeft: "90px",
                                }}
                              >
                                <h6 className="iq-title">
                                  <span className="cast-name text-white">
                                    {castMember.name}
                                  </span>
                                </h6>
                                
                                <div className="video-time align-items-center my-2" style={{textAlign: "swap"}}>
                                  <span className="text-white">
                                    <i className="ri-movie-line mr-1"></i>
                                    As {castMember.character}
                                  </span>
                                </div>
                                
                                {castMember.known_for_department && (
                                  <div className="cast-department text-white-50 text-center small">
                                    <span>
                                      <i className="ri-award-line mr-1"></i>
                                      {castMember.known_for_department}
                                    </span>
                                  </div>
                                )}
                                
                                <div className="cast-order text-center mt-2">
                                  <span className="badge badge-primary">
                                    #{castMember.order + 1}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section id="iq-rtl-direction" className="my-5">
            <Container fluid>
              <Row>
                <Col sm="12" className="overflow-hidden">
                  <div className="d-flex align-items-center justify-content-between mt-3">
                    <h4 className="main-title">Recommended Shows</h4>
                    <Link className="iq-view-all" to="/movie-category">
                      View All
                    </Link>
                  </div>
                  <div id="upcoming-contens">
                    <div
                      id="prev1"
                      className="swiper-button swiper-button-prev"
                    >
                      <i className="fa fa-chevron-left"></i>
                    </div>
                    <div
                      id="next1"
                      className="swiper-button swiper-button-next"
                    >
                      <i className="fa fa-chevron-right"></i>
                    </div>
                    <Swiper
                      breakpoints={{
                        320: { slidesPerView: 1 },
                        550: { slidesPerView: 2 },
                        991: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                      }}
                      navigation={{
                        prevEl: "#prev1",
                        nextEl: "#next1",
                      }}
                      loop={true}
                      slidesPerView={4}
                      spaceBetween={20}
                      as="ul"
                      className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                    >
                      {recommendedShows.loading ? (
                        <div className="col-12 py-5">
                          <div className="d-flex justify-content-center align-items-center">
                            <div className="text-center">
                              <div className="spinner-border text-primary mb-3" role="status">
                                <span className="sr-only">Loading recommended shows...</span>
                              </div>
                              <p className="text-white">Loading recommended shows...</p>
                            </div>
                          </div>
                        </div>
                      ) : recommendedShows.error ? (
                        <div className="col-12 py-5">
                          <div className="d-flex justify-content-center align-items-center">
                            <div className="text-center">
                              <i className="ri-error-warning-line text-warning mb-3" style={{fontSize: '3rem'}}></i>
                              <p className="text-white">Failed to load recommended shows</p>
                              <small className="text-white-50">{recommendedShows.error}</small>
                            </div>
                          </div>
                        </div>
                      ) : recommendedShows.shows.length === 0 ? (
                        <div className="col-12 py-5">
                          <div className="d-flex justify-content-center align-items-center">
                            <div className="text-center">
                              <i className="ri-tv-line text-primary mb-3" style={{fontSize: '3rem'}}></i>
                              <p className="text-white">No recommended shows available</p>
                              <small className="text-white-50">Please try refreshing the page</small>
                            </div>
                          </div>
                        </div>
                      ) : (
                        recommendedShows.shows.map((show, index) => (
                          <SwiperSlide as="li" key={show.id || index}>
                            <div className="block-images position-relative">
                              <div className="img-box">
                                <img
                                  src={show.poster_image_url }
                                  className="img-fluid "
                                  style={{height: '200px', width: '100%', objectFit: 'cover'}}
                                  alt={`${show.title} poster`}
                                  loading="lazy"
                                  onError={(e) => {
                                    e.target.src = upcoming1; // fallback to original image
                                  }}
                                />
                              </div>
                              
                              {/* Rating Overlay */}
                              <div className="video-overlay">
                                <div className="badge badge-primary">
                                  {show.vote_average_display}
                                </div>
                              </div>
                              
                              <div className="block-description">
                                <h6 className="iq-title">
                                  <Link to={`/show-details/${show.id}`}>{show.title}</Link>
                                </h6>
                                
                                <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                  <div className="badge badge-secondary p-1 mr-2">
                                    TV Show
                                  </div>
                                  <span className="text-white">
                                    {show.release_year}
                                  </span>
                                </div>
                                
                                {/* Show Overview */}
                                <div className="show-overview mb-2">
                                  <p className="text-white-50 small" 
                                     style={{
                                       fontSize: '0.8rem',
                                       lineHeight: '1.3',
                                       display: '-webkit-box',
                                       WebkitLineClamp: 2,
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden'
                                     }}
                                  >
                                    {show.overview}
                                  </p>
                                </div>
                                
                                <div className="hover-buttons">
                                  <Link
                                    to={`/show-details/${show.id}`}
                                    role="button"
                                    className="btn btn-hover iq-button"
                                  >
                                    <i className="fa fa-play mr-1" aria-hidden="true"></i>
                                    Play Now
                                  </Link>
                                </div>
                              </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                    <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                      <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                      <a
                                        onClick={copyURL}
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(show.id),
                                  title: show.title,
                                  type: 'tv',
                                  poster_path: show.poster_image_url?.includes('tmdb.org') ? show.poster_image_url.split('/').pop() : null,
                                  imgSrc: show.poster_image_url,
                                  vote_average: show.vote_average,
                                  release_date: show.release_year,
                                  overview: show.overview,
                                  adult: show.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                        ))
                      )}
                    </Swiper>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* <section id="iq-rtl-direction" className="my-5">
            <Container fluid>
              <Row>
                <Col sm="12" className="overflow-hidden">
                  <div className="d-flex align-items-center justify-content-between mt-3">
                    <h4 className="main-title">Related Shows</h4>
                    <Link className="iq-view-all" to="/movie-category">
                      View All
                    </Link>
                  </div>
                  <div id="upcoming-contens">
                    <div
                      id="prev2"
                      className="swiper-button swiper-button-prev"
                    >
                      <i className="fa fa-chevron-left"></i>
                    </div>
                    <div
                      id="next2"
                      className="swiper-button swiper-button-next"
                    >
                      <i className="fa fa-chevron-right"></i>
                    </div>
                    <Swiper
                      breakpoints={{
                        320: { slidesPerView: 1 },
                        550: { slidesPerView: 2 },
                        991: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                      }}
                      navigation={{
                        prevEl: "#prev2",
                        nextEl: "#next2",
                      }}
                      loop={true}
                      slidesPerView={4}
                      spaceBetween={20}
                      as="ul"
                      className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                    >
                      {related.map((item, index) => (
                        <SwiperSlide as="li" key={index}>
                          <div className=" block-images position-relative">
                            <div className="img-box">
                              <img
                                src={item?.imageUrl}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to="/movie-details">{item?.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {item?.ageRating}
                                </div>
                                <span className="text-white">
                                  {item?.duration}
                                </span>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to="/movie-details"
                                  role="button"
                                  className="btn btn-hover iq-button"
                                >
                                  <i
                                    className="fa fa-play mr-1"
                                    aria-hidden="true"
                                  ></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                    <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                      <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                      <a
                                        onClick={copyURL}
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(show.id),
                                  title: show.title,
                                  type: 'tv',
                                  poster_path: show.poster_image_url?.includes('tmdb.org') ? show.poster_image_url.split('/').pop() : null,
                                  imgSrc: show.poster_image_url,
                                  vote_average: show.vote_average,
                                  release_date: show.release_year,
                                  overview: show.overview,
                                  adult: show.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </Col>
              </Row>
            </Container>
          </section> */}

          {/* <section id="iq-rtl-direction" className="my-5">
            <Container fluid>
              <Row>
                <Col sm="12" className="overflow-hidden">
                  <div className="d-flex align-items-center justify-content-between mt-3">
                    <h4 className="main-title">Upcoming Shows</h4>
                    <Link className="iq-view-all" to="/movie-category">
                      View All
                    </Link>
                  </div>
                  <div id="upcoming-contens">
                    <div
                      id="prev3"
                      className="swiper-button swiper-button-prev"
                    >
                      <i className="fa fa-chevron-left"></i>
                    </div>
                    <div
                      id="next3"
                      className="swiper-button swiper-button-next"
                    >
                      <i className="fa fa-chevron-right"></i>
                    </div>
                    <Swiper
                      breakpoints={{
                        320: { slidesPerView: 1 },
                        550: { slidesPerView: 2 },
                        991: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                      }}
                      navigation={{
                        prevEl: "#prev3",
                        nextEl: "#next3",
                      }}
                      loop={true}
                      slidesPerView={4}
                      spaceBetween={20}
                      as="ul"
                      className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                    >
                      {related.map((item, index) => (
                        <SwiperSlide as="li" key={index}>
                          <div className=" block-images position-relative">
                            <div className="img-box">
                              <img
                                src={item?.imageUrl}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to="/movie-details">{item?.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {item?.ageRating}
                                </div>
                                <span className="text-white">
                                  {item?.duration}
                                </span>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to="/movie-details"
                                  role="button"
                                  className="btn btn-hover iq-button"
                                >
                                  <i
                                    className="fa fa-play mr-1"
                                    aria-hidden="true"
                                  ></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                    <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                      <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                      <a
                                       onClick={copyURL}
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(show.id),
                                  title: show.title,
                                  type: 'tv',
                                  poster_path: show.poster_image_url?.includes('tmdb.org') ? show.poster_image_url.split('/').pop() : null,
                                  imgSrc: show.poster_image_url,
                                  vote_average: show.vote_average,
                                  release_date: show.release_year,
                                  overview: show.overview,
                                  adult: show.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </Col>
              </Row>
            </Container>
          </section> */}
        </div>
      </div>
    </>
  );
};
export default ShowList;
